import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import {
  StaffBankAccountRequest,
  StaffBankAccountResponse,
  StaffBankAccountsService,
} from "lib-klab-sdks";
import { BankAccountsPort } from "../../../app/ports/organization/bank-accounts.port";
import {
  BankAccount,
  BankAccountRequest,
} from "../../../domain/models/organization/bank-account.model";

@Injectable({ providedIn: "root" })
export class BankAccountsPortAdapter implements BankAccountsPort {
  constructor(private readonly api: StaffBankAccountsService) {}

  list(filters?: {
    companyId?: number;
    status?: string;
    paymentTypeCode?: string;
    currencyCode?: string;
  }): Observable<BankAccount[]> {
    return this.api
      .list(filters)
      .pipe(map((items) => items.map(mapBankAccount)));
  }

  getById(id: number): Observable<BankAccount> {
    return this.api.getById(id).pipe(map(mapBankAccount));
  }

  create(request: BankAccountRequest): Observable<BankAccount> {
    return this.api.create(mapRequest(request)).pipe(map(mapBankAccount));
  }

  update(id: number, request: BankAccountRequest): Observable<BankAccount> {
    return this.api.update(id, mapRequest(request)).pipe(map(mapBankAccount));
  }

  setStatus(id: number, active: boolean): Observable<BankAccount> {
    return this.api.setStatus(id, active).pipe(map(mapBankAccount));
  }

  delete(id: number): Observable<void> {
    return this.api.delete(id);
  }
}

function mapBankAccount(item: StaffBankAccountResponse): BankAccount {
  return {
    id: item.bankAccountId,
    companyId: item.companyId,
    paymentTypeCode: item.paymentTypeCode,
    accountTypeCode: item.accountTypeCode,
    bankCode: item.bankCode,
    currencyCode: item.currencyCode,
    accountNumber: item.accountNumber,
    defaultAccount: item.defaultAccount,
    status: item.status,
  };
}

function mapRequest(request: BankAccountRequest): StaffBankAccountRequest {
  return { ...request };
}
